<template>
  <div class="w-full font-bold rounded-2xl" style="background-color: #2A3B4D;">
    <div class="text-white text-left p-3">
      <div class="flex items-center justify-between cursor-pointer" @click="toggleAccordion">
        <div class="">
          {{ title }}
        </div>
        <d-icon icon="chevron-down" />
      </div>
      <d-expand-transition v-show="isOpen">
        <div class="  pt-4">
          <div class="flex flex-col justify-center text-white ">
            <slot />
          </div>
        </div>
      </d-expand-transition>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      title: {
        type: String,
      },
    },

    data() {
      return {
        isOpen: true,

      };
    },

    methods: {

      toggleAccordion() {
        this.isOpen = !this.isOpen;
      },

    },
  };
</script>